import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class CapabilityApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<CapabilityApiModule> {
        return {
            ngModule: CapabilityApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: CapabilityApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('CapabilityApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
